module.exports = __webpack_public_path__ + "static/media/75mmD125.2cc6047d.png";